export default "__VITE_ASSET__CYg80ver__"